import React, { FC } from 'react';
import { TSocial } from './Contact';
import Numbers from './Numbers';

interface IInfo {
  social: TSocial;
}

const Info: FC<IInfo> = ({ social }): React.ReactElement => {
  const socialElements = Object.entries(social).map(([key, value], index) => {
    return (
      <li className="contact__social-item" key={`${value}_${index}`}>
        <a className="contact__social-link" href={value}>
          <img src={`/images/main/contact/images/icon/${key}.svg`} alt="Social icon" />
        </a>
      </li>
    );
  });

  return (
    <div className="contact__info">
      <h2 className="contact__info-title">Channel Partner Program</h2>

      <p className="contact__info-text_1">
        Whether you’re a technology consultant, software provider, or part of the management consulting ecosystem,
        partnering with SR ERP allows you to unlock new revenue streams, expand your service offerings, and enhance your
        market positioning.
      </p>

      <ul className="contact__social">{socialElements}</ul>
    </div>
  );
};

export default Info;
